<li *ngIf="variant === 'default'" class="item_container">
  <div class="label_container">
    <p>
      {{ label }}
    </p>
  </div>
  <div type="button" class="value_container">
    <p>
      {{ value }}
    </p>
    <button
      (click)="copyValue($event)"
      [class.copied]="isCopy"
      (mouseleave)="isCopy = false"
    >
      <svg
        class="icon"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 -960 960 960"
      >
        <path
          d="M360-240q-33 0-56.5-23.5T280-320v-480q0-33 23.5-56.5T360-880h360q33 0 56.5 23.5T800-800v480q0 33-23.5 56.5T720-240H360Zm0-80h360v-480H360v480ZM200-80q-33 0-56.5-23.5T120-160v-560h80v560h440v80H200Zm160-240v-480 480Z"
        />
      </svg>
    </button>
  </div>
</li>

<li *ngIf="variant === 'edit'" class="item_container">
  <div class="label_container">
    <p>
      {{ label }}
    </p>
  </div>

  <div *ngIf="!isEdit" type="button" class="value_container">
    <p>
      {{ value }}
    </p>
    <div style="display: flex">
      <button (click)="editValue($event)">
        <svg
          class="icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 -960 960 960"
          fill="currentColor"
        >
          <path
            d="M216-216h51l375-375-51-51-375 375v51Zm-72 72v-153l498-498q11-11 23.84-16 12.83-5 27-5 14.16 0 27.16 5t24 16l51 51q11 11 16 24t5 26.54q0 14.45-5.02 27.54T795-642L297-144H144Zm600-549-51-51 51 51Zm-127.95 76.95L591-642l51 51-25.95-25.05Z"
          />
        </svg>
      </button>
      <button
        (click)="copyValue($event)"
        [class.copied]="isCopy"
        (mouseleave)="isCopy = false"
      >
        <svg
          class="icon"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 -960 960 960"
        >
          <path
            d="M360-240q-33 0-56.5-23.5T280-320v-480q0-33 23.5-56.5T360-880h360q33 0 56.5 23.5T800-800v480q0 33-23.5 56.5T720-240H360Zm0-80h360v-480H360v480ZM200-80q-33 0-56.5-23.5T120-160v-560h80v560h440v80H200Zm160-240v-480 480Z"
          />
        </svg>
      </button>
    </div>
  </div>

  <div *ngIf="isEdit" type="button" class="value_container edit">
    <div class="input_container">
      <input
        #inputEdit
        type="text"
        [value]="value"
        autocomplete="off"
        placeholder="Ingrese el nuevo nombre"
        (click)="stopPropagation($event)"
        (keydown.enter)="acceptEdit($event)"
        (keydown.escape)="cancelEdit($event)"
      />
      <ng-container *ngIf="errorState$ | async as errorState">
        <div *ngIf="errorState.isError" class="error_container">
          <p>
            {{ errorState.errorMessage }}
          </p>
        </div>
      </ng-container>
    </div>
    <div class="edit_container">
      <button (click)="acceptEdit($event)">
        <svg
          class="icon icon_accept"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 -960 960 960"
          fill="currentColor"
        >
          <path
            d="m429-336 238-237-51-51-187 186-85-84-51 51 136 135Zm51 240q-79 0-149-30t-122.5-82.5Q156-261 126-331T96-480q0-80 30-149.5t82.5-122Q261-804 331-834t149-30q80 0 149.5 30t122 82.5Q804-699 834-629.5T864-480q0 79-30 149t-82.5 122.5Q699-156 629.5-126T480-96Zm0-72q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Zm0-312Z"
          />
        </svg>
      </button>
      <button (click)="cancelEdit($event)">
        <svg
          class="icon icon_cancel"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 -960 960 960"
          fill="currentColor"
        >
          <path
            d="m339-288 141-141 141 141 51-51-141-141 141-141-51-51-141 141-141-141-51 51 141 141-141 141 51 51ZM480-96q-79 0-149-30t-122.5-82.5Q156-261 126-331T96-480q0-80 30-149.5t82.5-122Q261-804 331-834t149-30q80 0 149.5 30t122 82.5Q804-699 834-629.5T864-480q0 79-30 149t-82.5 122.5Q699-156 629.5-126T480-96Zm0-72q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Zm0-312Z"
          />
        </svg>
      </button>
    </div>
  </div>
</li>
